import React, { useCallback, useEffect } from "react";
import { clearAllBodyScrollLocks, disableBodyScroll } from "body-scroll-lock";

import Icon from "../Icon";
import { Link } from "react-router-dom";
import Product from "./Product";
import cn from "classnames";
import { createPortal } from "react-dom";
import styles from "./ModalProduct.module.sass";

const ModalProduct = ({ visible, onClose, records, sorting }) => {
  const escFunction = useCallback(
    (e) => {
      if (e.keyCode === 27) {
        onClose();
      }
    },
    [onClose]
  );

  useEffect(() => {
    document.addEventListener("keydown", escFunction, false);
    return () => {
      document.removeEventListener("keydown", escFunction, false);
    };
  }, [escFunction]);

  useEffect(() => {
    if (visible) {
      const target = document.querySelector("#modal-product");
      disableBodyScroll(target);
    } else {
      clearAllBodyScrollLocks();
    }
  }, [visible]);

  return createPortal(
    visible && (
      <div id="modal-product" className={styles.modal}>
        <div className={styles.control}>
          {/* <Link
            className={cn("button-white", styles.button)}
            to="/products/add"
          >
            Edit product
          </Link> */}
          <button className={styles.close} onClick={onClose}>
            <Icon name="close" size="20" />
          </button>
        </div>
        <div className={styles.outer}>
          <Product records={records} sorting={sorting} />
        </div>
      </div>
    ),
    document.body
  );
};

export default ModalProduct;
